import { ENTER, SPACE, BACKSPACE, DELETE, TAB, hasModifierKey, UP_ARROW, DOWN_ARROW } from '@angular/cdk/keycodes';
import * as i0 from '@angular/core';
import { InjectionToken, inject, ElementRef, booleanAttribute, numberAttribute, Input, Directive, ChangeDetectorRef, HOST_TAG_NAME, NgZone, DOCUMENT, EventEmitter, Injector, ViewChild, ContentChild, Output, ContentChildren, ViewEncapsulation, Component, Renderer2, afterNextRender, QueryList, forwardRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl, Validators, NgForm, FormGroupDirective } from '@angular/forms';
import { takeUntil, startWith, switchMap } from 'rxjs/operators';
import { FocusMonitor, _IdGenerator, FocusKeyManager } from '@angular/cdk/a11y';
import { _CdkPrivateStyleLoader, _VisuallyHiddenLoader } from '@angular/cdk/private';
import { Subject, merge } from 'rxjs';
import { _StructuralStylesLoader } from './_structural-styles-chunk.mjs';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from './_ripple-chunk.mjs';
import { _animationsDisabled } from './_animation-chunk.mjs';
import { MatRippleLoader } from './_ripple-loader-chunk.mjs';
import { Directionality, BidiModule } from '@angular/cdk/bidi';
import { ErrorStateMatcher } from './_error-options-chunk.mjs';
import { _ErrorStateTracker } from './_error-state-chunk.mjs';
import { MatFormFieldControl, MAT_FORM_FIELD } from './_form-field-chunk.mjs';
import { MatRippleModule } from './_ripple-module-chunk.mjs';
import '@angular/cdk/platform';
import '@angular/cdk/coercion';
import '@angular/cdk/layout';
import '@angular/common';
import '@angular/cdk/observers/private';
const _c0 = ["*", [["mat-chip-avatar"], ["", "matChipAvatar", ""]], [["mat-chip-trailing-icon"], ["", "matChipRemove", ""], ["", "matChipTrailingIcon", ""]]];
const _c1 = ["*", "mat-chip-avatar, [matChipAvatar]", "mat-chip-trailing-icon,[matChipRemove],[matChipTrailingIcon]"];
function MatChip_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function MatChip_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
function MatChipOption_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 8);
    i0.ɵɵelement(4, "path", 9);
    i0.ɵɵelementEnd()()();
  }
}
function MatChipOption_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
}
const _c2 = ".mdc-evolution-chip,\n.mdc-evolution-chip__cell,\n.mdc-evolution-chip__action {\n  display: inline-flex;\n  align-items: center;\n}\n\n.mdc-evolution-chip {\n  position: relative;\n  max-width: 100%;\n}\n\n.mdc-evolution-chip__cell,\n.mdc-evolution-chip__action {\n  height: 100%;\n}\n\n.mdc-evolution-chip__cell--primary {\n  flex-basis: 100%;\n  overflow-x: hidden;\n}\n\n.mdc-evolution-chip__cell--trailing {\n  flex: 1 0 auto;\n}\n\n.mdc-evolution-chip__action {\n  align-items: center;\n  background: none;\n  border: none;\n  box-sizing: content-box;\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  outline: none;\n  padding: 0;\n  text-decoration: none;\n  color: inherit;\n}\n\n.mdc-evolution-chip__action--presentational {\n  cursor: auto;\n}\n\n.mdc-evolution-chip--disabled,\n.mdc-evolution-chip__action:disabled {\n  pointer-events: none;\n}\n@media (forced-colors: active) {\n  .mdc-evolution-chip--disabled,\n  .mdc-evolution-chip__action:disabled {\n    forced-color-adjust: none;\n  }\n}\n\n.mdc-evolution-chip__action--primary {\n  font: inherit;\n  letter-spacing: inherit;\n  white-space: inherit;\n  overflow-x: hidden;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__action--primary::before {\n  border-width: var(--mat-chip-outline-width, 1px);\n  border-radius: var(--mat-chip-container-shape-radius, 8px);\n  box-sizing: border-box;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  pointer-events: none;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  border-style: solid;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--primary::before {\n  border-color: var(--mat-chip-outline-color, var(--mat-sys-outline));\n}\n.mdc-evolution-chip__action--primary:not(.mdc-evolution-chip__action--presentational):not(.mdc-ripple-upgraded):focus::before {\n  border-color: var(--mat-chip-focus-outline-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--primary::before {\n  border-color: var(--mat-chip-disabled-outline-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__action--primary::before {\n  border-width: var(--mat-chip-flat-selected-outline-width, 0);\n}\n.mat-mdc-basic-chip .mdc-evolution-chip__action--primary {\n  font: inherit;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.mdc-evolution-chip__action--secondary {\n  position: relative;\n  overflow: visible;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--secondary {\n  color: var(--mat-chip-with-trailing-icon-trailing-icon-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--secondary {\n  color: var(--mat-chip-with-trailing-icon-disabled-trailing-icon-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, .mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, [dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.mdc-evolution-chip__text-label {\n  -webkit-user-select: none;\n  user-select: none;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__text-label {\n  font-family: var(--mat-chip-label-text-font, var(--mat-sys-label-large-font));\n  line-height: var(--mat-chip-label-text-line-height, var(--mat-sys-label-large-line-height));\n  font-size: var(--mat-chip-label-text-size, var(--mat-sys-label-large-size));\n  font-weight: var(--mat-chip-label-text-weight, var(--mat-sys-label-large-weight));\n  letter-spacing: var(--mat-chip-label-text-tracking, var(--mat-sys-label-large-tracking));\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label {\n  color: var(--mat-chip-label-text-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label {\n  color: var(--mat-chip-selected-label-text-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label, .mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label {\n  color: var(--mat-chip-disabled-label-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent));\n}\n\n.mdc-evolution-chip__graphic {\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n  overflow: hidden;\n  pointer-events: none;\n  position: relative;\n  flex: 1 0 auto;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__graphic {\n  width: var(--mat-chip-with-avatar-avatar-size, 24px);\n  height: var(--mat-chip-with-avatar-avatar-size, 24px);\n  font-size: var(--mat-chip-with-avatar-avatar-size, 24px);\n}\n.mdc-evolution-chip--selecting .mdc-evolution-chip__graphic {\n  transition: width 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.mdc-evolution-chip--selectable:not(.mdc-evolution-chip--selected):not(.mdc-evolution-chip--with-primary-icon) .mdc-evolution-chip__graphic {\n  width: 0;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic {\n  padding-left: 4px;\n  padding-right: 8px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic {\n  padding-left: 8px;\n  padding-right: 4px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic {\n  padding-left: 4px;\n  padding-right: 8px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic {\n  padding-left: 8px;\n  padding-right: 4px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__graphic {\n  padding-left: 0;\n}\n\n.mdc-evolution-chip__checkmark {\n  position: absolute;\n  opacity: 0;\n  top: 50%;\n  left: 50%;\n  height: 20px;\n  width: 20px;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__checkmark {\n  color: var(--mat-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__checkmark {\n  color: var(--mat-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface));\n}\n.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark {\n  transition: transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate(-75%, -50%);\n}\n.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark {\n  transform: translate(-50%, -50%);\n  opacity: 1;\n}\n\n.mdc-evolution-chip__checkmark-svg {\n  display: block;\n}\n\n.mdc-evolution-chip__checkmark-path {\n  stroke-width: 2px;\n  stroke-dasharray: 29.7833385;\n  stroke-dashoffset: 29.7833385;\n  stroke: currentColor;\n}\n.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark-path {\n  transition: stroke-dashoffset 150ms 45ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark-path {\n  stroke-dashoffset: 0;\n}\n@media (forced-colors: active) {\n  .mdc-evolution-chip__checkmark-path {\n    stroke: CanvasText !important;\n  }\n}\n\n.mat-mdc-standard-chip .mdc-evolution-chip__icon--trailing {\n  height: 18px;\n  width: 18px;\n  font-size: 18px;\n}\n.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove {\n  opacity: calc(var(--mat-chip-trailing-action-opacity, 1) * var(--mat-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38));\n}\n.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove:focus {\n  opacity: calc(var(--mat-chip-trailing-action-focus-opacity, 1) * var(--mat-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38));\n}\n\n.mat-mdc-standard-chip {\n  border-radius: var(--mat-chip-container-shape-radius, 8px);\n  height: var(--mat-chip-container-height, 32px);\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n  background-color: var(--mat-chip-elevated-container-color, transparent);\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled {\n  background-color: var(--mat-chip-elevated-disabled-container-color);\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled) {\n  background-color: var(--mat-chip-elevated-selected-container-color, var(--mat-sys-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled {\n  background-color: var(--mat-chip-flat-disabled-selected-container-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent));\n}\n@media (forced-colors: active) {\n  .mat-mdc-standard-chip {\n    outline: solid 1px;\n  }\n}\n\n.mat-mdc-standard-chip .mdc-evolution-chip__icon--primary {\n  border-radius: var(--mat-chip-with-avatar-avatar-shape-radius, 24px);\n  width: var(--mat-chip-with-icon-icon-size, 18px);\n  height: var(--mat-chip-with-icon-icon-size, 18px);\n  font-size: var(--mat-chip-with-icon-icon-size, 18px);\n}\n.mdc-evolution-chip--selected .mdc-evolution-chip__icon--primary {\n  opacity: 0;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__icon--primary {\n  color: var(--mat-chip-with-icon-icon-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--primary {\n  color: var(--mat-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface));\n}\n\n.mat-mdc-chip-highlighted {\n  --mat-chip-with-icon-icon-color: var(--mat-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container));\n  --mat-chip-elevated-container-color: var(--mat-chip-elevated-selected-container-color, var(--mat-sys-secondary-container));\n  --mat-chip-label-text-color: var(--mat-chip-selected-label-text-color, var(--mat-sys-on-secondary-container));\n  --mat-chip-outline-width: var(--mat-chip-flat-selected-outline-width, 0);\n}\n\n.mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-chip-selected .mat-mdc-chip-focus-overlay, .mat-mdc-chip-highlighted .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-chip:hover .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-hover-state-layer-color, var(--mat-sys-on-surface-variant));\n  opacity: var(--mat-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity));\n}\n.mat-mdc-chip-focus-overlay .mat-mdc-chip-selected:hover, .mat-mdc-chip-highlighted:hover .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-selected-hover-state-layer-color, var(--mat-sys-on-secondary-container));\n  opacity: var(--mat-chip-selected-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity));\n}\n.mat-mdc-chip.cdk-focused .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant));\n  opacity: var(--mat-chip-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity));\n}\n.mat-mdc-chip-selected.cdk-focused .mat-mdc-chip-focus-overlay, .mat-mdc-chip-highlighted.cdk-focused .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container));\n  opacity: var(--mat-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity));\n}\n\n.mdc-evolution-chip--disabled:not(.mdc-evolution-chip--selected) .mat-mdc-chip-avatar {\n  opacity: var(--mat-chip-with-avatar-disabled-avatar-opacity, 0.38);\n}\n\n.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing {\n  opacity: var(--mat-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38);\n}\n\n.mdc-evolution-chip--disabled.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark {\n  opacity: var(--mat-chip-with-icon-disabled-icon-opacity, 0.38);\n}\n\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled {\n  opacity: var(--mat-chip-disabled-container-opacity, 1);\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__icon--trailing, .mat-mdc-standard-chip.mat-mdc-chip-highlighted .mdc-evolution-chip__icon--trailing {\n  color: var(--mat-chip-selected-trailing-icon-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing {\n  color: var(--mat-chip-selected-disabled-trailing-icon-color, var(--mat-sys-on-surface));\n}\n\n.mat-mdc-chip-edit, .mat-mdc-chip-remove {\n  opacity: var(--mat-chip-trailing-action-opacity, 1);\n}\n.mat-mdc-chip-edit:focus, .mat-mdc-chip-remove:focus {\n  opacity: var(--mat-chip-trailing-action-focus-opacity, 1);\n}\n.mat-mdc-chip-edit::after, .mat-mdc-chip-remove::after {\n  background-color: var(--mat-chip-trailing-action-state-layer-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-chip-edit:hover::after, .mat-mdc-chip-remove:hover::after {\n  opacity: calc(var(--mat-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)) + var(--mat-chip-trailing-action-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)));\n}\n.mat-mdc-chip-edit:focus::after, .mat-mdc-chip-remove:focus::after {\n  opacity: calc(var(--mat-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)) + var(--mat-chip-trailing-action-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)));\n}\n\n.mat-mdc-chip-selected .mat-mdc-chip-remove::after,\n.mat-mdc-chip-highlighted .mat-mdc-chip-remove::after {\n  background-color: var(--mat-chip-selected-trailing-action-state-layer-color, var(--mat-sys-on-secondary-container));\n}\n\n.mat-mdc-chip.cdk-focused .mat-mdc-chip-edit:focus::after, .mat-mdc-chip.cdk-focused .mat-mdc-chip-remove:focus::after {\n  opacity: calc(var(--mat-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)) + var(--mat-chip-trailing-action-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)));\n}\n.mat-mdc-chip.cdk-focused .mat-mdc-chip-edit:hover::after, .mat-mdc-chip.cdk-focused .mat-mdc-chip-remove:hover::after {\n  opacity: calc(var(--mat-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)) + var(--mat-chip-trailing-action-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)));\n}\n\n.mat-mdc-standard-chip {\n  -webkit-tap-highlight-color: transparent;\n}\n.mat-mdc-standard-chip .mat-mdc-chip-graphic,\n.mat-mdc-standard-chip .mat-mdc-chip-trailing-icon {\n  box-sizing: content-box;\n}\n.mat-mdc-standard-chip._mat-animation-noopable,\n.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__graphic,\n.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark,\n.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark-path {\n  transition-duration: 1ms;\n  animation-duration: 1ms;\n}\n\n.mat-mdc-chip-focus-overlay {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n  border-radius: inherit;\n  transition: opacity 150ms linear;\n}\n._mat-animation-noopable .mat-mdc-chip-focus-overlay {\n  transition: none;\n}\n.mat-mdc-basic-chip .mat-mdc-chip-focus-overlay {\n  display: none;\n}\n\n.mat-mdc-chip .mat-ripple.mat-mdc-chip-ripple {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  pointer-events: none;\n  border-radius: inherit;\n}\n\n.mat-mdc-chip-avatar {\n  text-align: center;\n  line-height: 1;\n  color: var(--mat-chip-with-icon-icon-color, currentColor);\n}\n\n.mat-mdc-chip {\n  position: relative;\n  z-index: 0;\n}\n\n.mat-mdc-chip-action-label {\n  text-align: left;\n  z-index: 1;\n}\n[dir=rtl] .mat-mdc-chip-action-label {\n  text-align: right;\n}\n.mat-mdc-chip.mdc-evolution-chip--with-trailing-action .mat-mdc-chip-action-label {\n  position: relative;\n}\n.mat-mdc-chip-action-label .mat-mdc-chip-primary-focus-indicator {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.mat-mdc-chip-action-label .mat-focus-indicator::before {\n  margin: calc(calc(var(--mat-focus-indicator-border-width, 3px) + 2px) * -1);\n}\n\n.mat-mdc-chip-edit::before, .mat-mdc-chip-remove::before {\n  margin: calc(var(--mat-focus-indicator-border-width, 3px) * -1);\n  left: 8px;\n  right: 8px;\n}\n.mat-mdc-chip-edit::after, .mat-mdc-chip-remove::after {\n  content: \"\";\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: -3px;\n  bottom: -3px;\n  left: 5px;\n  right: 5px;\n  border-radius: 50%;\n  box-sizing: border-box;\n  padding: 12px;\n  margin: -12px;\n  background-clip: content-box;\n}\n.mat-mdc-chip-edit .mat-icon, .mat-mdc-chip-remove .mat-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n  box-sizing: content-box;\n}\n\n.mat-chip-edit-input {\n  cursor: text;\n  display: inline-block;\n  color: inherit;\n  outline: 0;\n}\n\n@media (forced-colors: active) {\n  .mat-mdc-chip-selected:not(.mat-mdc-chip-multiple) {\n    outline-width: 3px;\n  }\n}\n\n.mat-mdc-chip-action:focus-visible .mat-focus-indicator::before {\n  content: \"\";\n}\n\n.mdc-evolution-chip__icon, .mat-mdc-chip-edit .mat-icon, .mat-mdc-chip-remove .mat-icon {\n  min-height: fit-content;\n}\n\nimg.mdc-evolution-chip__icon {\n  min-height: 0;\n}\n";
const _c3 = [[["", "matChipEdit", ""]], [["mat-chip-avatar"], ["", "matChipAvatar", ""]], [["", "matChipEditInput", ""]], "*", [["mat-chip-trailing-icon"], ["", "matChipRemove", ""], ["", "matChipTrailingIcon", ""]]];
const _c4 = ["[matChipEdit]", "mat-chip-avatar, [matChipAvatar]", "[matChipEditInput]", "*", "mat-chip-trailing-icon,[matChipRemove],[matChipTrailingIcon]"];
function MatChipRow_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
}
function MatChipRow_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function MatChipRow_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function MatChipRow_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2);
  }
}
function MatChipRow_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
}
function MatChipRow_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MatChipRow_Conditional_5_Conditional_0_Template, 1, 0)(1, MatChipRow_Conditional_5_Conditional_1_Template, 1, 0, "span", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.contentEditInput ? 0 : 1);
  }
}
function MatChipRow_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3);
  }
}
function MatChipRow_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵprojection(1, 4);
    i0.ɵɵelementEnd();
  }
}
const _c5 = ["*"];
const _c6 = ".mat-mdc-chip-set {\n  display: flex;\n}\n.mat-mdc-chip-set:focus {\n  outline: none;\n}\n.mat-mdc-chip-set .mdc-evolution-chip-set__chips {\n  min-width: 100%;\n  margin-left: -8px;\n  margin-right: 0;\n}\n.mat-mdc-chip-set .mdc-evolution-chip {\n  margin: 4px 0 4px 8px;\n}\n[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip-set__chips {\n  margin-left: 0;\n  margin-right: -8px;\n}\n[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip {\n  margin-left: 0;\n  margin-right: 8px;\n}\n\n.mdc-evolution-chip-set__chips {\n  display: flex;\n  flex-flow: wrap;\n  min-width: 0;\n}\n\n.mat-mdc-chip-set-stacked {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.mat-mdc-chip-set-stacked .mat-mdc-chip {\n  width: 100%;\n}\n.mat-mdc-chip-set-stacked .mdc-evolution-chip__graphic {\n  flex-grow: 0;\n}\n.mat-mdc-chip-set-stacked .mdc-evolution-chip__action--primary {\n  flex-basis: 100%;\n  justify-content: start;\n}\n\ninput.mat-mdc-chip-input {\n  flex: 1 0 150px;\n  margin-left: 8px;\n}\n[dir=rtl] input.mat-mdc-chip-input {\n  margin-left: 0;\n  margin-right: 8px;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input::placeholder {\n  opacity: 1;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input::-moz-placeholder {\n  opacity: 1;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input::-webkit-input-placeholder {\n  opacity: 1;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input:-ms-input-placeholder {\n  opacity: 1;\n}\n.mat-mdc-chip-set + input.mat-mdc-chip-input {\n  margin-left: 0;\n  margin-right: 0;\n}\n";
const MAT_CHIPS_DEFAULT_OPTIONS = /*#__PURE__*/new InjectionToken('mat-chips-default-options', {
  providedIn: 'root',
  factory: () => ({
    separatorKeyCodes: [ENTER]
  })
});
const MAT_CHIP_AVATAR = /*#__PURE__*/new InjectionToken('MatChipAvatar');
const MAT_CHIP_TRAILING_ICON = /*#__PURE__*/new InjectionToken('MatChipTrailingIcon');
const MAT_CHIP_EDIT = /*#__PURE__*/new InjectionToken('MatChipEdit');
const MAT_CHIP_REMOVE = /*#__PURE__*/new InjectionToken('MatChipRemove');
const MAT_CHIP = /*#__PURE__*/new InjectionToken('MatChip');
let MatChipContent = /*#__PURE__*/(() => {
  class MatChipContent {
    _elementRef = inject(ElementRef);
    _parentChip = inject(MAT_CHIP);
    _isPrimary = true;
    _isLeading = false;
    get disabled() {
      return this._disabled || this._parentChip?.disabled || false;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled = false;
    tabIndex = -1;
    _allowFocusWhenDisabled = false;
    _getDisabledAttribute() {
      return this.disabled && !this._allowFocusWhenDisabled ? '' : null;
    }
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_StructuralStylesLoader);
      if (this._elementRef.nativeElement.nodeName === 'BUTTON') {
        this._elementRef.nativeElement.setAttribute('type', 'button');
      }
    }
    focus() {
      this._elementRef.nativeElement.focus();
    }
    static ɵfac = function MatChipContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipContent)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipContent,
      selectors: [["", "matChipContent", ""]],
      hostAttrs: [1, "mat-mdc-chip-action", "mdc-evolution-chip__action", "mdc-evolution-chip__action--presentational"],
      hostVars: 8,
      hostBindings: function MatChipContent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("disabled", ctx._getDisabledAttribute())("aria-disabled", ctx.disabled);
          i0.ɵɵclassProp("mdc-evolution-chip__action--primary", ctx._isPrimary)("mdc-evolution-chip__action--secondary", !ctx._isPrimary)("mdc-evolution-chip__action--trailing", !ctx._isPrimary && !ctx._isLeading);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        tabIndex: [2, "tabIndex", "tabIndex", value => value == null ? -1 : numberAttribute(value)],
        _allowFocusWhenDisabled: "_allowFocusWhenDisabled"
      }
    });
  }
  return MatChipContent;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipAction = /*#__PURE__*/(() => {
  class MatChipAction extends MatChipContent {
    _getTabindex() {
      return this.disabled && !this._allowFocusWhenDisabled ? null : this.tabIndex.toString();
    }
    _handleClick(event) {
      if (!this.disabled && this._isPrimary) {
        event.preventDefault();
        this._parentChip._handlePrimaryActionInteraction();
      }
    }
    _handleKeydown(event) {
      if ((event.keyCode === ENTER || event.keyCode === SPACE) && !this.disabled && this._isPrimary && !this._parentChip._isEditing) {
        event.preventDefault();
        this._parentChip._handlePrimaryActionInteraction();
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipAction_BaseFactory;
      return function MatChipAction_Factory(__ngFactoryType__) {
        return (ɵMatChipAction_BaseFactory || (ɵMatChipAction_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipAction)))(__ngFactoryType__ || MatChipAction);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipAction,
      selectors: [["", "matChipAction", ""]],
      hostVars: 3,
      hostBindings: function MatChipAction_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function MatChipAction_click_HostBindingHandler($event) {
            return ctx._handleClick($event);
          })("keydown", function MatChipAction_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx._getTabindex());
          i0.ɵɵclassProp("mdc-evolution-chip__action--presentational", false);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatChipAction;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipAvatar = /*#__PURE__*/(() => {
  class MatChipAvatar {
    static ɵfac = function MatChipAvatar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipAvatar)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipAvatar,
      selectors: [["mat-chip-avatar"], ["", "matChipAvatar", ""]],
      hostAttrs: ["role", "img", 1, "mat-mdc-chip-avatar", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--primary"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_AVATAR,
        useExisting: MatChipAvatar
      }])]
    });
  }
  return MatChipAvatar;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipTrailingIcon = /*#__PURE__*/(() => {
  class MatChipTrailingIcon extends MatChipContent {
    _isPrimary = false;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipTrailingIcon_BaseFactory;
      return function MatChipTrailingIcon_Factory(__ngFactoryType__) {
        return (ɵMatChipTrailingIcon_BaseFactory || (ɵMatChipTrailingIcon_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipTrailingIcon)))(__ngFactoryType__ || MatChipTrailingIcon);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipTrailingIcon,
      selectors: [["mat-chip-trailing-icon"], ["", "matChipTrailingIcon", ""]],
      hostAttrs: ["aria-hidden", "true", 1, "mat-mdc-chip-trailing-icon", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--trailing"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_TRAILING_ICON,
        useExisting: MatChipTrailingIcon
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatChipTrailingIcon;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipEdit = /*#__PURE__*/(() => {
  class MatChipEdit extends MatChipAction {
    _isPrimary = false;
    _isLeading = true;
    _handleClick(event) {
      if (!this.disabled) {
        event.stopPropagation();
        event.preventDefault();
        this._parentChip._edit(event);
      }
    }
    _handleKeydown(event) {
      if ((event.keyCode === ENTER || event.keyCode === SPACE) && !this.disabled) {
        event.stopPropagation();
        event.preventDefault();
        this._parentChip._edit(event);
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipEdit_BaseFactory;
      return function MatChipEdit_Factory(__ngFactoryType__) {
        return (ɵMatChipEdit_BaseFactory || (ɵMatChipEdit_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipEdit)))(__ngFactoryType__ || MatChipEdit);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipEdit,
      selectors: [["", "matChipEdit", ""]],
      hostAttrs: ["role", "button", 1, "mat-mdc-chip-edit", "mat-mdc-chip-avatar", "mat-focus-indicator", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--primary"],
      hostVars: 1,
      hostBindings: function MatChipEdit_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-hidden", null);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_EDIT,
        useExisting: MatChipEdit
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatChipEdit;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipRemove = /*#__PURE__*/(() => {
  class MatChipRemove extends MatChipAction {
    _isPrimary = false;
    _handleClick(event) {
      if (!this.disabled) {
        event.stopPropagation();
        event.preventDefault();
        this._parentChip.remove();
      }
    }
    _handleKeydown(event) {
      if ((event.keyCode === ENTER || event.keyCode === SPACE) && !this.disabled) {
        event.stopPropagation();
        event.preventDefault();
        this._parentChip.remove();
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipRemove_BaseFactory;
      return function MatChipRemove_Factory(__ngFactoryType__) {
        return (ɵMatChipRemove_BaseFactory || (ɵMatChipRemove_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipRemove)))(__ngFactoryType__ || MatChipRemove);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipRemove,
      selectors: [["", "matChipRemove", ""]],
      hostAttrs: ["role", "button", 1, "mat-mdc-chip-remove", "mat-mdc-chip-trailing-icon", "mat-focus-indicator", "mdc-evolution-chip__icon", "mdc-evolution-chip__icon--trailing"],
      hostVars: 1,
      hostBindings: function MatChipRemove_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-hidden", null);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP_REMOVE,
        useExisting: MatChipRemove
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatChipRemove;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChip = /*#__PURE__*/(() => {
  class MatChip {
    _changeDetectorRef = inject(ChangeDetectorRef);
    _elementRef = inject(ElementRef);
    _tagName = inject(HOST_TAG_NAME);
    _ngZone = inject(NgZone);
    _focusMonitor = inject(FocusMonitor);
    _globalRippleOptions = inject(MAT_RIPPLE_GLOBAL_OPTIONS, {
      optional: true
    });
    _document = inject(DOCUMENT);
    _onFocus = new Subject();
    _onBlur = new Subject();
    _isBasicChip = false;
    role = null;
    _hasFocusInternal = false;
    _pendingFocus = false;
    _actionChanges;
    _animationsDisabled = _animationsDisabled();
    _allLeadingIcons;
    _allTrailingIcons;
    _allEditIcons;
    _allRemoveIcons;
    _hasFocus() {
      return this._hasFocusInternal;
    }
    id = inject(_IdGenerator).getId('mat-mdc-chip-');
    ariaLabel = null;
    ariaDescription = null;
    _chipListDisabled = false;
    _hadFocusOnRemove = false;
    _textElement;
    get value() {
      return this._value !== undefined ? this._value : this._textElement.textContent.trim();
    }
    set value(value) {
      this._value = value;
    }
    _value;
    color;
    removable = true;
    highlighted = false;
    disableRipple = false;
    get disabled() {
      return this._disabled || this._chipListDisabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled = false;
    removed = new EventEmitter();
    destroyed = new EventEmitter();
    basicChipAttrName = 'mat-basic-chip';
    leadingIcon;
    editIcon;
    trailingIcon;
    removeIcon;
    primaryAction;
    _rippleLoader = inject(MatRippleLoader);
    _injector = inject(Injector);
    constructor() {
      const styleLoader = inject(_CdkPrivateStyleLoader);
      styleLoader.load(_StructuralStylesLoader);
      styleLoader.load(_VisuallyHiddenLoader);
      this._monitorFocus();
      this._rippleLoader?.configureRipple(this._elementRef.nativeElement, {
        className: 'mat-mdc-chip-ripple',
        disabled: this._isRippleDisabled()
      });
    }
    ngOnInit() {
      this._isBasicChip = this._elementRef.nativeElement.hasAttribute(this.basicChipAttrName) || this._tagName.toLowerCase() === this.basicChipAttrName;
    }
    ngAfterViewInit() {
      this._textElement = this._elementRef.nativeElement.querySelector('.mat-mdc-chip-action-label');
      if (this._pendingFocus) {
        this._pendingFocus = false;
        this.focus();
      }
    }
    ngAfterContentInit() {
      this._actionChanges = merge(this._allLeadingIcons.changes, this._allTrailingIcons.changes, this._allEditIcons.changes, this._allRemoveIcons.changes).subscribe(() => this._changeDetectorRef.markForCheck());
    }
    ngDoCheck() {
      this._rippleLoader.setDisabled(this._elementRef.nativeElement, this._isRippleDisabled());
    }
    ngOnDestroy() {
      this.destroyed.emit({
        chip: this
      });
      this.destroyed.complete();
      this._focusMonitor.stopMonitoring(this._elementRef);
      this._rippleLoader?.destroyRipple(this._elementRef.nativeElement);
      this._actionChanges?.unsubscribe();
    }
    remove() {
      if (this.removable) {
        this._hadFocusOnRemove = this._hasFocus();
        this.removed.emit({
          chip: this
        });
      }
    }
    _isRippleDisabled() {
      return this.disabled || this.disableRipple || this._animationsDisabled || this._isBasicChip || !this._hasInteractiveActions() || !!this._globalRippleOptions?.disabled;
    }
    _hasTrailingIcon() {
      return !!(this.trailingIcon || this.removeIcon);
    }
    _handleKeydown(event) {
      if (event.keyCode === BACKSPACE && !event.repeat || event.keyCode === DELETE) {
        event.preventDefault();
        this.remove();
      }
    }
    focus() {
      if (!this.disabled) {
        if (this.primaryAction) {
          this.primaryAction.focus();
        } else {
          this._pendingFocus = true;
        }
      }
    }
    _getSourceAction(target) {
      return this._getActions().find(action => {
        const element = action._elementRef.nativeElement;
        return element === target || element.contains(target);
      });
    }
    _getActions() {
      const result = [];
      if (this.editIcon) {
        result.push(this.editIcon);
      }
      if (this.primaryAction) {
        result.push(this.primaryAction);
      }
      if (this.removeIcon) {
        result.push(this.removeIcon);
      }
      return result;
    }
    _handlePrimaryActionInteraction() {}
    _hasInteractiveActions() {
      return this._getActions().length > 0;
    }
    _edit(event) {}
    _monitorFocus() {
      this._focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
        const hasFocus = origin !== null;
        if (hasFocus !== this._hasFocusInternal) {
          this._hasFocusInternal = hasFocus;
          if (hasFocus) {
            this._onFocus.next({
              chip: this
            });
          } else {
            this._changeDetectorRef.markForCheck();
            setTimeout(() => this._ngZone.run(() => this._onBlur.next({
              chip: this
            })));
          }
        }
      });
    }
    static ɵfac = function MatChip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChip)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChip,
      selectors: [["mat-basic-chip"], ["", "mat-basic-chip", ""], ["mat-chip"], ["", "mat-chip", ""]],
      contentQueries: function MatChip_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MAT_CHIP_AVATAR, 5)(dirIndex, MAT_CHIP_EDIT, 5)(dirIndex, MAT_CHIP_TRAILING_ICON, 5)(dirIndex, MAT_CHIP_REMOVE, 5)(dirIndex, MAT_CHIP_AVATAR, 5)(dirIndex, MAT_CHIP_TRAILING_ICON, 5)(dirIndex, MAT_CHIP_EDIT, 5)(dirIndex, MAT_CHIP_REMOVE, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.leadingIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trailingIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.removeIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allLeadingIcons = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allTrailingIcons = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allEditIcons = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._allRemoveIcons = _t);
        }
      },
      viewQuery: function MatChip_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatChipAction, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.primaryAction = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-chip"],
      hostVars: 31,
      hostBindings: function MatChip_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MatChip_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("id", ctx.id);
          i0.ɵɵattribute("role", ctx.role)("aria-label", ctx.ariaLabel);
          i0.ɵɵclassMap("mat-" + (ctx.color || "primary"));
          i0.ɵɵclassProp("mdc-evolution-chip", !ctx._isBasicChip)("mdc-evolution-chip--disabled", ctx.disabled)("mdc-evolution-chip--with-trailing-action", ctx._hasTrailingIcon())("mdc-evolution-chip--with-primary-graphic", ctx.leadingIcon)("mdc-evolution-chip--with-primary-icon", ctx.leadingIcon)("mdc-evolution-chip--with-avatar", ctx.leadingIcon)("mat-mdc-chip-with-avatar", ctx.leadingIcon)("mat-mdc-chip-highlighted", ctx.highlighted)("mat-mdc-chip-disabled", ctx.disabled)("mat-mdc-basic-chip", ctx._isBasicChip)("mat-mdc-standard-chip", !ctx._isBasicChip)("mat-mdc-chip-with-trailing-icon", ctx._hasTrailingIcon())("_mat-animation-noopable", ctx._animationsDisabled);
        }
      },
      inputs: {
        role: "role",
        id: "id",
        ariaLabel: [0, "aria-label", "ariaLabel"],
        ariaDescription: [0, "aria-description", "ariaDescription"],
        value: "value",
        color: "color",
        removable: [2, "removable", "removable", booleanAttribute],
        highlighted: [2, "highlighted", "highlighted", booleanAttribute],
        disableRipple: [2, "disableRipple", "disableRipple", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        removed: "removed",
        destroyed: "destroyed"
      },
      exportAs: ["matChip"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MAT_CHIP,
        useExisting: MatChip
      }])],
      ngContentSelectors: _c1,
      decls: 8,
      vars: 2,
      consts: [[1, "mat-mdc-chip-focus-overlay"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--primary"], ["matChipContent", ""], [1, "mdc-evolution-chip__graphic", "mat-mdc-chip-graphic"], [1, "mdc-evolution-chip__text-label", "mat-mdc-chip-action-label"], [1, "mat-mdc-chip-primary-focus-indicator", "mat-focus-indicator"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--trailing"]],
      template: function MatChip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵelement(0, "span", 0);
          i0.ɵɵelementStart(1, "span", 1)(2, "span", 2);
          i0.ɵɵconditionalCreate(3, MatChip_Conditional_3_Template, 2, 0, "span", 3);
          i0.ɵɵelementStart(4, "span", 4);
          i0.ɵɵprojection(5);
          i0.ɵɵelement(6, "span", 5);
          i0.ɵɵelementEnd()()();
          i0.ɵɵconditionalCreate(7, MatChip_Conditional_7_Template, 2, 0, "span", 6);
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.leadingIcon ? 3 : -1);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx._hasTrailingIcon() ? 7 : -1);
        }
      },
      dependencies: [MatChipContent],
      styles: [".mdc-evolution-chip,\n.mdc-evolution-chip__cell,\n.mdc-evolution-chip__action {\n  display: inline-flex;\n  align-items: center;\n}\n\n.mdc-evolution-chip {\n  position: relative;\n  max-width: 100%;\n}\n\n.mdc-evolution-chip__cell,\n.mdc-evolution-chip__action {\n  height: 100%;\n}\n\n.mdc-evolution-chip__cell--primary {\n  flex-basis: 100%;\n  overflow-x: hidden;\n}\n\n.mdc-evolution-chip__cell--trailing {\n  flex: 1 0 auto;\n}\n\n.mdc-evolution-chip__action {\n  align-items: center;\n  background: none;\n  border: none;\n  box-sizing: content-box;\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  outline: none;\n  padding: 0;\n  text-decoration: none;\n  color: inherit;\n}\n\n.mdc-evolution-chip__action--presentational {\n  cursor: auto;\n}\n\n.mdc-evolution-chip--disabled,\n.mdc-evolution-chip__action:disabled {\n  pointer-events: none;\n}\n@media (forced-colors: active) {\n  .mdc-evolution-chip--disabled,\n  .mdc-evolution-chip__action:disabled {\n    forced-color-adjust: none;\n  }\n}\n\n.mdc-evolution-chip__action--primary {\n  font: inherit;\n  letter-spacing: inherit;\n  white-space: inherit;\n  overflow-x: hidden;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__action--primary::before {\n  border-width: var(--mat-chip-outline-width, 1px);\n  border-radius: var(--mat-chip-container-shape-radius, 8px);\n  box-sizing: border-box;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  pointer-events: none;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  border-style: solid;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--primary::before {\n  border-color: var(--mat-chip-outline-color, var(--mat-sys-outline));\n}\n.mdc-evolution-chip__action--primary:not(.mdc-evolution-chip__action--presentational):not(.mdc-ripple-upgraded):focus::before {\n  border-color: var(--mat-chip-focus-outline-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--primary::before {\n  border-color: var(--mat-chip-disabled-outline-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__action--primary::before {\n  border-width: var(--mat-chip-flat-selected-outline-width, 0);\n}\n.mat-mdc-basic-chip .mdc-evolution-chip__action--primary {\n  font: inherit;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n[dir=rtl] .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__action--primary {\n  padding-left: 12px;\n  padding-right: 0;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--primary {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.mdc-evolution-chip__action--secondary {\n  position: relative;\n  overflow: visible;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__action--secondary {\n  color: var(--mat-chip-with-trailing-icon-trailing-icon-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__action--secondary {\n  color: var(--mat-chip-with-trailing-icon-disabled-trailing-icon-color, var(--mat-sys-on-surface));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, .mat-mdc-standard-chip.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, .mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__action--secondary, [dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__action--secondary {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.mdc-evolution-chip__text-label {\n  -webkit-user-select: none;\n  user-select: none;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__text-label {\n  font-family: var(--mat-chip-label-text-font, var(--mat-sys-label-large-font));\n  line-height: var(--mat-chip-label-text-line-height, var(--mat-sys-label-large-line-height));\n  font-size: var(--mat-chip-label-text-size, var(--mat-sys-label-large-size));\n  font-weight: var(--mat-chip-label-text-weight, var(--mat-sys-label-large-weight));\n  letter-spacing: var(--mat-chip-label-text-tracking, var(--mat-sys-label-large-tracking));\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label {\n  color: var(--mat-chip-label-text-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__text-label {\n  color: var(--mat-chip-selected-label-text-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label, .mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__text-label {\n  color: var(--mat-chip-disabled-label-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent));\n}\n\n.mdc-evolution-chip__graphic {\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n  overflow: hidden;\n  pointer-events: none;\n  position: relative;\n  flex: 1 0 auto;\n}\n.mat-mdc-standard-chip .mdc-evolution-chip__graphic {\n  width: var(--mat-chip-with-avatar-avatar-size, 24px);\n  height: var(--mat-chip-with-avatar-avatar-size, 24px);\n  font-size: var(--mat-chip-with-avatar-avatar-size, 24px);\n}\n.mdc-evolution-chip--selecting .mdc-evolution-chip__graphic {\n  transition: width 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.mdc-evolution-chip--selectable:not(.mdc-evolution-chip--selected):not(.mdc-evolution-chip--with-primary-icon) .mdc-evolution-chip__graphic {\n  width: 0;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic {\n  padding-left: 4px;\n  padding-right: 8px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic .mdc-evolution-chip__graphic {\n  padding-left: 8px;\n  padding-right: 4px;\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic {\n  padding-left: 4px;\n  padding-right: 8px;\n}\n[dir=rtl] .mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-trailing-action .mdc-evolution-chip__graphic {\n  padding-left: 8px;\n  padding-right: 4px;\n}\n.mdc-evolution-chip--with-avatar.mdc-evolution-chip--with-primary-graphic.mdc-evolution-chip--with-leading-action .mdc-evolution-chip__graphic {\n  padding-left: 0;\n}\n\n.mdc-evolution-chip__checkmark {\n  position: absolute;\n  opacity: 0;\n  top: 50%;\n  left: 50%;\n  height: 20px;\n  width: 20px;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__checkmark {\n  color: var(--mat-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__checkmark {\n  color: var(--mat-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface));\n}\n.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark {\n  transition: transform 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate(-75%, -50%);\n}\n.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark {\n  transform: translate(-50%, -50%);\n  opacity: 1;\n}\n\n.mdc-evolution-chip__checkmark-svg {\n  display: block;\n}\n\n.mdc-evolution-chip__checkmark-path {\n  stroke-width: 2px;\n  stroke-dasharray: 29.7833385;\n  stroke-dashoffset: 29.7833385;\n  stroke: currentColor;\n}\n.mdc-evolution-chip--selecting .mdc-evolution-chip__checkmark-path {\n  transition: stroke-dashoffset 150ms 45ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark-path {\n  stroke-dashoffset: 0;\n}\n@media (forced-colors: active) {\n  .mdc-evolution-chip__checkmark-path {\n    stroke: CanvasText !important;\n  }\n}\n\n.mat-mdc-standard-chip .mdc-evolution-chip__icon--trailing {\n  height: 18px;\n  width: 18px;\n  font-size: 18px;\n}\n.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove {\n  opacity: calc(var(--mat-chip-trailing-action-opacity, 1) * var(--mat-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38));\n}\n.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing.mat-mdc-chip-remove:focus {\n  opacity: calc(var(--mat-chip-trailing-action-focus-opacity, 1) * var(--mat-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38));\n}\n\n.mat-mdc-standard-chip {\n  border-radius: var(--mat-chip-container-shape-radius, 8px);\n  height: var(--mat-chip-container-height, 32px);\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n  background-color: var(--mat-chip-elevated-container-color, transparent);\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled {\n  background-color: var(--mat-chip-elevated-disabled-container-color);\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected:not(.mdc-evolution-chip--disabled) {\n  background-color: var(--mat-chip-elevated-selected-container-color, var(--mat-sys-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled {\n  background-color: var(--mat-chip-flat-disabled-selected-container-color, color-mix(in srgb, var(--mat-sys-on-surface) 12%, transparent));\n}\n@media (forced-colors: active) {\n  .mat-mdc-standard-chip {\n    outline: solid 1px;\n  }\n}\n\n.mat-mdc-standard-chip .mdc-evolution-chip__icon--primary {\n  border-radius: var(--mat-chip-with-avatar-avatar-shape-radius, 24px);\n  width: var(--mat-chip-with-icon-icon-size, 18px);\n  height: var(--mat-chip-with-icon-icon-size, 18px);\n  font-size: var(--mat-chip-with-icon-icon-size, 18px);\n}\n.mdc-evolution-chip--selected .mdc-evolution-chip__icon--primary {\n  opacity: 0;\n}\n.mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) .mdc-evolution-chip__icon--primary {\n  color: var(--mat-chip-with-icon-icon-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--primary {\n  color: var(--mat-chip-with-icon-disabled-icon-color, var(--mat-sys-on-surface));\n}\n\n.mat-mdc-chip-highlighted {\n  --mat-chip-with-icon-icon-color: var(--mat-chip-with-icon-selected-icon-color, var(--mat-sys-on-secondary-container));\n  --mat-chip-elevated-container-color: var(--mat-chip-elevated-selected-container-color, var(--mat-sys-secondary-container));\n  --mat-chip-label-text-color: var(--mat-chip-selected-label-text-color, var(--mat-sys-on-secondary-container));\n  --mat-chip-outline-width: var(--mat-chip-flat-selected-outline-width, 0);\n}\n\n.mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-chip-selected .mat-mdc-chip-focus-overlay, .mat-mdc-chip-highlighted .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-chip:hover .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-hover-state-layer-color, var(--mat-sys-on-surface-variant));\n  opacity: var(--mat-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity));\n}\n.mat-mdc-chip-focus-overlay .mat-mdc-chip-selected:hover, .mat-mdc-chip-highlighted:hover .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-selected-hover-state-layer-color, var(--mat-sys-on-secondary-container));\n  opacity: var(--mat-chip-selected-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity));\n}\n.mat-mdc-chip.cdk-focused .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-focus-state-layer-color, var(--mat-sys-on-surface-variant));\n  opacity: var(--mat-chip-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity));\n}\n.mat-mdc-chip-selected.cdk-focused .mat-mdc-chip-focus-overlay, .mat-mdc-chip-highlighted.cdk-focused .mat-mdc-chip-focus-overlay {\n  background: var(--mat-chip-selected-focus-state-layer-color, var(--mat-sys-on-secondary-container));\n  opacity: var(--mat-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity));\n}\n\n.mdc-evolution-chip--disabled:not(.mdc-evolution-chip--selected) .mat-mdc-chip-avatar {\n  opacity: var(--mat-chip-with-avatar-disabled-avatar-opacity, 0.38);\n}\n\n.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing {\n  opacity: var(--mat-chip-with-trailing-icon-disabled-trailing-icon-opacity, 0.38);\n}\n\n.mdc-evolution-chip--disabled.mdc-evolution-chip--selected .mdc-evolution-chip__checkmark {\n  opacity: var(--mat-chip-with-icon-disabled-icon-opacity, 0.38);\n}\n\n.mat-mdc-standard-chip.mdc-evolution-chip--disabled {\n  opacity: var(--mat-chip-disabled-container-opacity, 1);\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected .mdc-evolution-chip__icon--trailing, .mat-mdc-standard-chip.mat-mdc-chip-highlighted .mdc-evolution-chip__icon--trailing {\n  color: var(--mat-chip-selected-trailing-icon-color, var(--mat-sys-on-secondary-container));\n}\n.mat-mdc-standard-chip.mdc-evolution-chip--selected.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing, .mat-mdc-standard-chip.mat-mdc-chip-highlighted.mdc-evolution-chip--disabled .mdc-evolution-chip__icon--trailing {\n  color: var(--mat-chip-selected-disabled-trailing-icon-color, var(--mat-sys-on-surface));\n}\n\n.mat-mdc-chip-edit, .mat-mdc-chip-remove {\n  opacity: var(--mat-chip-trailing-action-opacity, 1);\n}\n.mat-mdc-chip-edit:focus, .mat-mdc-chip-remove:focus {\n  opacity: var(--mat-chip-trailing-action-focus-opacity, 1);\n}\n.mat-mdc-chip-edit::after, .mat-mdc-chip-remove::after {\n  background-color: var(--mat-chip-trailing-action-state-layer-color, var(--mat-sys-on-surface-variant));\n}\n.mat-mdc-chip-edit:hover::after, .mat-mdc-chip-remove:hover::after {\n  opacity: calc(var(--mat-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)) + var(--mat-chip-trailing-action-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)));\n}\n.mat-mdc-chip-edit:focus::after, .mat-mdc-chip-remove:focus::after {\n  opacity: calc(var(--mat-chip-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)) + var(--mat-chip-trailing-action-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)));\n}\n\n.mat-mdc-chip-selected .mat-mdc-chip-remove::after,\n.mat-mdc-chip-highlighted .mat-mdc-chip-remove::after {\n  background-color: var(--mat-chip-selected-trailing-action-state-layer-color, var(--mat-sys-on-secondary-container));\n}\n\n.mat-mdc-chip.cdk-focused .mat-mdc-chip-edit:focus::after, .mat-mdc-chip.cdk-focused .mat-mdc-chip-remove:focus::after {\n  opacity: calc(var(--mat-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)) + var(--mat-chip-trailing-action-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)));\n}\n.mat-mdc-chip.cdk-focused .mat-mdc-chip-edit:hover::after, .mat-mdc-chip.cdk-focused .mat-mdc-chip-remove:hover::after {\n  opacity: calc(var(--mat-chip-selected-focus-state-layer-opacity, var(--mat-sys-focus-state-layer-opacity)) + var(--mat-chip-trailing-action-hover-state-layer-opacity, var(--mat-sys-hover-state-layer-opacity)));\n}\n\n.mat-mdc-standard-chip {\n  -webkit-tap-highlight-color: transparent;\n}\n.mat-mdc-standard-chip .mat-mdc-chip-graphic,\n.mat-mdc-standard-chip .mat-mdc-chip-trailing-icon {\n  box-sizing: content-box;\n}\n.mat-mdc-standard-chip._mat-animation-noopable,\n.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__graphic,\n.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark,\n.mat-mdc-standard-chip._mat-animation-noopable .mdc-evolution-chip__checkmark-path {\n  transition-duration: 1ms;\n  animation-duration: 1ms;\n}\n\n.mat-mdc-chip-focus-overlay {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n  border-radius: inherit;\n  transition: opacity 150ms linear;\n}\n._mat-animation-noopable .mat-mdc-chip-focus-overlay {\n  transition: none;\n}\n.mat-mdc-basic-chip .mat-mdc-chip-focus-overlay {\n  display: none;\n}\n\n.mat-mdc-chip .mat-ripple.mat-mdc-chip-ripple {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  pointer-events: none;\n  border-radius: inherit;\n}\n\n.mat-mdc-chip-avatar {\n  text-align: center;\n  line-height: 1;\n  color: var(--mat-chip-with-icon-icon-color, currentColor);\n}\n\n.mat-mdc-chip {\n  position: relative;\n  z-index: 0;\n}\n\n.mat-mdc-chip-action-label {\n  text-align: left;\n  z-index: 1;\n}\n[dir=rtl] .mat-mdc-chip-action-label {\n  text-align: right;\n}\n.mat-mdc-chip.mdc-evolution-chip--with-trailing-action .mat-mdc-chip-action-label {\n  position: relative;\n}\n.mat-mdc-chip-action-label .mat-mdc-chip-primary-focus-indicator {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.mat-mdc-chip-action-label .mat-focus-indicator::before {\n  margin: calc(calc(var(--mat-focus-indicator-border-width, 3px) + 2px) * -1);\n}\n\n.mat-mdc-chip-edit::before, .mat-mdc-chip-remove::before {\n  margin: calc(var(--mat-focus-indicator-border-width, 3px) * -1);\n  left: 8px;\n  right: 8px;\n}\n.mat-mdc-chip-edit::after, .mat-mdc-chip-remove::after {\n  content: \"\";\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: -3px;\n  bottom: -3px;\n  left: 5px;\n  right: 5px;\n  border-radius: 50%;\n  box-sizing: border-box;\n  padding: 12px;\n  margin: -12px;\n  background-clip: content-box;\n}\n.mat-mdc-chip-edit .mat-icon, .mat-mdc-chip-remove .mat-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n  box-sizing: content-box;\n}\n\n.mat-chip-edit-input {\n  cursor: text;\n  display: inline-block;\n  color: inherit;\n  outline: 0;\n}\n\n@media (forced-colors: active) {\n  .mat-mdc-chip-selected:not(.mat-mdc-chip-multiple) {\n    outline-width: 3px;\n  }\n}\n\n.mat-mdc-chip-action:focus-visible .mat-focus-indicator::before {\n  content: \"\";\n}\n\n.mdc-evolution-chip__icon, .mat-mdc-chip-edit .mat-icon, .mat-mdc-chip-remove .mat-icon {\n  min-height: fit-content;\n}\n\nimg.mdc-evolution-chip__icon {\n  min-height: 0;\n}\n"],
      encapsulation: 2
    });
  }
  return MatChip;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MatChipSelectionChange {
  source;
  selected;
  isUserInput;
  constructor(source, selected, isUserInput = false) {
    this.source = source;
    this.selected = selected;
    this.isUserInput = isUserInput;
  }
}
let MatChipOption = /*#__PURE__*/(() => {
  class MatChipOption extends MatChip {
    _defaultOptions = inject(MAT_CHIPS_DEFAULT_OPTIONS, {
      optional: true
    });
    chipListSelectable = true;
    _chipListMultiple = false;
    _chipListHideSingleSelectionIndicator = this._defaultOptions?.hideSingleSelectionIndicator ?? false;
    get selectable() {
      return this._selectable && this.chipListSelectable;
    }
    set selectable(value) {
      this._selectable = value;
      this._changeDetectorRef.markForCheck();
    }
    _selectable = true;
    get selected() {
      return this._selected;
    }
    set selected(value) {
      this._setSelectedState(value, false, true);
    }
    _selected = false;
    get ariaSelected() {
      return this.selectable ? this.selected.toString() : null;
    }
    basicChipAttrName = 'mat-basic-chip-option';
    selectionChange = new EventEmitter();
    ngOnInit() {
      super.ngOnInit();
      this.role = 'presentation';
    }
    select() {
      this._setSelectedState(true, false, true);
    }
    deselect() {
      this._setSelectedState(false, false, true);
    }
    selectViaInteraction() {
      this._setSelectedState(true, true, true);
    }
    toggleSelected(isUserInput = false) {
      this._setSelectedState(!this.selected, isUserInput, true);
      return this.selected;
    }
    _handlePrimaryActionInteraction() {
      if (!this.disabled) {
        this.focus();
        if (this.selectable) {
          this.toggleSelected(true);
        }
      }
    }
    _hasLeadingGraphic() {
      if (this.leadingIcon) {
        return true;
      }
      return !this._chipListHideSingleSelectionIndicator || this._chipListMultiple;
    }
    _setSelectedState(isSelected, isUserInput, emitEvent) {
      if (isSelected !== this.selected) {
        this._selected = isSelected;
        if (emitEvent) {
          this.selectionChange.emit({
            source: this,
            isUserInput,
            selected: this.selected
          });
        }
        this._changeDetectorRef.markForCheck();
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipOption_BaseFactory;
      return function MatChipOption_Factory(__ngFactoryType__) {
        return (ɵMatChipOption_BaseFactory || (ɵMatChipOption_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipOption)))(__ngFactoryType__ || MatChipOption);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipOption,
      selectors: [["mat-basic-chip-option"], ["", "mat-basic-chip-option", ""], ["mat-chip-option"], ["", "mat-chip-option", ""]],
      hostAttrs: [1, "mat-mdc-chip", "mat-mdc-chip-option"],
      hostVars: 37,
      hostBindings: function MatChipOption_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵdomProperty("id", ctx.id);
          i0.ɵɵattribute("tabindex", null)("aria-label", null)("aria-description", null)("role", ctx.role);
          i0.ɵɵclassProp("mdc-evolution-chip", !ctx._isBasicChip)("mdc-evolution-chip--filter", !ctx._isBasicChip)("mdc-evolution-chip--selectable", !ctx._isBasicChip)("mat-mdc-chip-selected", ctx.selected)("mat-mdc-chip-multiple", ctx._chipListMultiple)("mat-mdc-chip-disabled", ctx.disabled)("mat-mdc-chip-with-avatar", ctx.leadingIcon)("mdc-evolution-chip--disabled", ctx.disabled)("mdc-evolution-chip--selected", ctx.selected)("mdc-evolution-chip--selecting", !ctx._animationsDisabled)("mdc-evolution-chip--with-trailing-action", ctx._hasTrailingIcon())("mdc-evolution-chip--with-primary-icon", ctx.leadingIcon)("mdc-evolution-chip--with-primary-graphic", ctx._hasLeadingGraphic())("mdc-evolution-chip--with-avatar", ctx.leadingIcon)("mat-mdc-chip-highlighted", ctx.highlighted)("mat-mdc-chip-with-trailing-icon", ctx._hasTrailingIcon());
        }
      },
      inputs: {
        selectable: [2, "selectable", "selectable", booleanAttribute],
        selected: [2, "selected", "selected", booleanAttribute]
      },
      outputs: {
        selectionChange: "selectionChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatChip,
        useExisting: MatChipOption
      }, {
        provide: MAT_CHIP,
        useExisting: MatChipOption
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 8,
      vars: 6,
      consts: [[1, "mat-mdc-chip-focus-overlay"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--primary"], ["matChipAction", "", "role", "option", 3, "_allowFocusWhenDisabled"], [1, "mdc-evolution-chip__graphic", "mat-mdc-chip-graphic"], [1, "mdc-evolution-chip__text-label", "mat-mdc-chip-action-label"], [1, "mat-mdc-chip-primary-focus-indicator", "mat-focus-indicator"], [1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--trailing"], [1, "mdc-evolution-chip__checkmark"], ["viewBox", "-2 -3 30 30", "focusable", "false", "aria-hidden", "true", 1, "mdc-evolution-chip__checkmark-svg"], ["fill", "none", "stroke", "currentColor", "d", "M1.73,12.91 8.1,19.28 22.79,4.59", 1, "mdc-evolution-chip__checkmark-path"]],
      template: function MatChipOption_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵelement(0, "span", 0);
          i0.ɵɵelementStart(1, "span", 1)(2, "button", 2);
          i0.ɵɵconditionalCreate(3, MatChipOption_Conditional_3_Template, 5, 0, "span", 3);
          i0.ɵɵelementStart(4, "span", 4);
          i0.ɵɵprojection(5);
          i0.ɵɵelement(6, "span", 5);
          i0.ɵɵelementEnd()()();
          i0.ɵɵconditionalCreate(7, MatChipOption_Conditional_7_Template, 2, 0, "span", 6);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("_allowFocusWhenDisabled", true);
          i0.ɵɵattribute("aria-description", ctx.ariaDescription)("aria-label", ctx.ariaLabel)("aria-selected", ctx.ariaSelected);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx._hasLeadingGraphic() ? 3 : -1);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx._hasTrailingIcon() ? 7 : -1);
        }
      },
      dependencies: [MatChipAction],
      styles: [_c2],
      encapsulation: 2
    });
  }
  return MatChipOption;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipEditInput = /*#__PURE__*/(() => {
  class MatChipEditInput {
    _elementRef = inject(ElementRef);
    _document = inject(DOCUMENT);
    initialize(initialValue) {
      this.getNativeElement().focus();
      this.setValue(initialValue);
    }
    getNativeElement() {
      return this._elementRef.nativeElement;
    }
    setValue(value) {
      this.getNativeElement().textContent = value;
      this._moveCursorToEndOfInput();
    }
    getValue() {
      return this.getNativeElement().textContent || '';
    }
    _moveCursorToEndOfInput() {
      const range = this._document.createRange();
      range.selectNodeContents(this.getNativeElement());
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
    static ɵfac = function MatChipEditInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipEditInput)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipEditInput,
      selectors: [["span", "matChipEditInput", ""]],
      hostAttrs: ["role", "textbox", "tabindex", "-1", "contenteditable", "true", 1, "mat-chip-edit-input"]
    });
  }
  return MatChipEditInput;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipRow = /*#__PURE__*/(() => {
  class MatChipRow extends MatChip {
    basicChipAttrName = 'mat-basic-chip-row';
    _renderer = inject(Renderer2);
    _cleanupMousedown;
    _editStartPending = false;
    editable = false;
    edited = new EventEmitter();
    defaultEditInput;
    contentEditInput;
    _alreadyFocused = false;
    _isEditing = false;
    constructor() {
      super();
      this.role = 'row';
      this._onBlur.pipe(takeUntil(this.destroyed)).subscribe(() => {
        if (this._isEditing && !this._editStartPending) {
          this._onEditFinish();
        }
        this._alreadyFocused = false;
      });
    }
    ngAfterViewInit() {
      super.ngAfterViewInit();
      this._cleanupMousedown = this._ngZone.runOutsideAngular(() => this._renderer.listen(this._elementRef.nativeElement, 'mousedown', () => {
        this._alreadyFocused = this._hasFocus();
      }));
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this._cleanupMousedown?.();
    }
    _hasLeadingActionIcon() {
      return !this._isEditing && !!this.editIcon;
    }
    _hasTrailingIcon() {
      return !this._isEditing && super._hasTrailingIcon();
    }
    _handleFocus() {
      if (!this._isEditing && !this.disabled) {
        this.focus();
      }
    }
    _handleKeydown(event) {
      if (event.keyCode === ENTER && !this.disabled) {
        if (this._isEditing) {
          event.preventDefault();
          this._onEditFinish();
        } else if (this.editable) {
          this._startEditing(event);
        }
      } else if (this._isEditing) {
        event.stopPropagation();
      } else {
        super._handleKeydown(event);
      }
    }
    _handleClick(event) {
      if (!this.disabled && this.editable && !this._isEditing && this._alreadyFocused) {
        event.preventDefault();
        event.stopPropagation();
        this._startEditing(event);
      }
    }
    _handleDoubleclick(event) {
      if (!this.disabled && this.editable) {
        this._startEditing(event);
      }
    }
    _edit() {
      this._changeDetectorRef.markForCheck();
      this._startEditing();
    }
    _startEditing(event) {
      if (!this.primaryAction || this.removeIcon && !!event && this._getSourceAction(event.target) === this.removeIcon) {
        return;
      }
      const value = this.value;
      this._isEditing = this._editStartPending = true;
      afterNextRender(() => {
        this._getEditInput().initialize(value);
        setTimeout(() => this._ngZone.run(() => this._editStartPending = false));
      }, {
        injector: this._injector
      });
    }
    _onEditFinish() {
      this._isEditing = this._editStartPending = false;
      this.edited.emit({
        chip: this,
        value: this._getEditInput().getValue()
      });
      if (this._document.activeElement === this._getEditInput().getNativeElement() || this._document.activeElement === this._document.body) {
        this.primaryAction.focus();
      }
    }
    _isRippleDisabled() {
      return super._isRippleDisabled() || this._isEditing;
    }
    _getEditInput() {
      return this.contentEditInput || this.defaultEditInput;
    }
    static ɵfac = function MatChipRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipRow)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipRow,
      selectors: [["mat-chip-row"], ["", "mat-chip-row", ""], ["mat-basic-chip-row"], ["", "mat-basic-chip-row", ""]],
      contentQueries: function MatChipRow_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChipEditInput, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentEditInput = _t.first);
        }
      },
      viewQuery: function MatChipRow_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatChipEditInput, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultEditInput = _t.first);
        }
      },
      hostAttrs: [1, "mat-mdc-chip", "mat-mdc-chip-row", "mdc-evolution-chip"],
      hostVars: 29,
      hostBindings: function MatChipRow_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatChipRow_focus_HostBindingHandler() {
            return ctx._handleFocus();
          })("click", function MatChipRow_click_HostBindingHandler($event) {
            return ctx._hasInteractiveActions() ? ctx._handleClick($event) : null;
          })("dblclick", function MatChipRow_dblclick_HostBindingHandler($event) {
            return ctx._handleDoubleclick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("id", ctx.id);
          i0.ɵɵattribute("tabindex", ctx.disabled ? null : -1)("aria-label", null)("aria-description", null)("role", ctx.role);
          i0.ɵɵclassProp("mat-mdc-chip-with-avatar", ctx.leadingIcon)("mat-mdc-chip-disabled", ctx.disabled)("mat-mdc-chip-editing", ctx._isEditing)("mat-mdc-chip-editable", ctx.editable)("mdc-evolution-chip--disabled", ctx.disabled)("mdc-evolution-chip--with-leading-action", ctx._hasLeadingActionIcon())("mdc-evolution-chip--with-trailing-action", ctx._hasTrailingIcon())("mdc-evolution-chip--with-primary-graphic", ctx.leadingIcon)("mdc-evolution-chip--with-primary-icon", ctx.leadingIcon)("mdc-evolution-chip--with-avatar", ctx.leadingIcon)("mat-mdc-chip-highlighted", ctx.highlighted)("mat-mdc-chip-with-trailing-icon", ctx._hasTrailingIcon());
        }
      },
      inputs: {
        editable: "editable"
      },
      outputs: {
        edited: "edited"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatChip,
        useExisting: MatChipRow
      }, {
        provide: MAT_CHIP,
        useExisting: MatChipRow
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c4,
      decls: 9,
      vars: 8,
      consts: [[1, "mat-mdc-chip-focus-overlay"], ["role", "gridcell", 1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--leading"], ["role", "gridcell", "matChipAction", "", 1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--primary", 3, "disabled"], [1, "mdc-evolution-chip__graphic", "mat-mdc-chip-graphic"], [1, "mdc-evolution-chip__text-label", "mat-mdc-chip-action-label"], ["aria-hidden", "true", 1, "mat-mdc-chip-primary-focus-indicator", "mat-focus-indicator"], ["role", "gridcell", 1, "mdc-evolution-chip__cell", "mdc-evolution-chip__cell--trailing"], ["matChipEditInput", ""]],
      template: function MatChipRow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵconditionalCreate(0, MatChipRow_Conditional_0_Template, 1, 0, "span", 0);
          i0.ɵɵconditionalCreate(1, MatChipRow_Conditional_1_Template, 2, 0, "span", 1);
          i0.ɵɵelementStart(2, "span", 2);
          i0.ɵɵconditionalCreate(3, MatChipRow_Conditional_3_Template, 2, 0, "span", 3);
          i0.ɵɵelementStart(4, "span", 4);
          i0.ɵɵconditionalCreate(5, MatChipRow_Conditional_5_Template, 2, 1)(6, MatChipRow_Conditional_6_Template, 1, 0);
          i0.ɵɵelement(7, "span", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵconditionalCreate(8, MatChipRow_Conditional_8_Template, 2, 0, "span", 6);
        }
        if (rf & 2) {
          i0.ɵɵconditional(!ctx._isEditing ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx._hasLeadingActionIcon() ? 1 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵattribute("aria-description", ctx.ariaDescription)("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.leadingIcon ? 3 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx._isEditing ? 5 : 6);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx._hasTrailingIcon() ? 8 : -1);
        }
      },
      dependencies: [MatChipAction, MatChipEditInput],
      styles: [_c2],
      encapsulation: 2
    });
  }
  return MatChipRow;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipSet = /*#__PURE__*/(() => {
  class MatChipSet {
    _elementRef = inject(ElementRef);
    _changeDetectorRef = inject(ChangeDetectorRef);
    _dir = inject(Directionality, {
      optional: true
    });
    _lastDestroyedFocusedChipIndex = null;
    _keyManager;
    _destroyed = new Subject();
    _defaultRole = 'presentation';
    get chipFocusChanges() {
      return this._getChipStream(chip => chip._onFocus);
    }
    get chipDestroyedChanges() {
      return this._getChipStream(chip => chip.destroyed);
    }
    get chipRemovedChanges() {
      return this._getChipStream(chip => chip.removed);
    }
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
      this._syncChipsState();
    }
    _disabled = false;
    get empty() {
      return !this._chips || this._chips.length === 0;
    }
    get role() {
      if (this._explicitRole) {
        return this._explicitRole;
      }
      return this.empty ? null : this._defaultRole;
    }
    tabIndex = 0;
    set role(value) {
      this._explicitRole = value;
    }
    _explicitRole = null;
    get focused() {
      return this._hasFocusedChip();
    }
    _chips;
    _chipActions = new QueryList();
    ngAfterViewInit() {
      this._setUpFocusManagement();
      this._trackChipSetChanges();
      this._trackDestroyedFocusedChip();
    }
    ngOnDestroy() {
      this._keyManager?.destroy();
      this._chipActions.destroy();
      this._destroyed.next();
      this._destroyed.complete();
    }
    _hasFocusedChip() {
      return this._chips && this._chips.some(chip => chip._hasFocus());
    }
    _syncChipsState() {
      this._chips?.forEach(chip => {
        chip._chipListDisabled = this._disabled;
        chip._changeDetectorRef.markForCheck();
      });
    }
    focus() {}
    _handleKeydown(event) {
      if (this._originatesFromChip(event)) {
        this._keyManager.onKeydown(event);
      }
    }
    _isValidIndex(index) {
      return index >= 0 && index < this._chips.length;
    }
    _allowFocusEscape() {
      const previous = this._elementRef.nativeElement.tabIndex;
      if (previous !== -1) {
        this._elementRef.nativeElement.tabIndex = -1;
        setTimeout(() => this._elementRef.nativeElement.tabIndex = previous);
      }
    }
    _getChipStream(mappingFunction) {
      return this._chips.changes.pipe(startWith(null), switchMap(() => merge(...this._chips.map(mappingFunction))));
    }
    _originatesFromChip(event) {
      let currentElement = event.target;
      while (currentElement && currentElement !== this._elementRef.nativeElement) {
        if (currentElement.classList.contains('mat-mdc-chip')) {
          return true;
        }
        currentElement = currentElement.parentElement;
      }
      return false;
    }
    _setUpFocusManagement() {
      this._chips.changes.pipe(startWith(this._chips)).subscribe(chips => {
        const actions = [];
        chips.forEach(chip => chip._getActions().forEach(action => actions.push(action)));
        this._chipActions.reset(actions);
        this._chipActions.notifyOnChanges();
      });
      this._keyManager = new FocusKeyManager(this._chipActions).withVerticalOrientation().withHorizontalOrientation(this._dir ? this._dir.value : 'ltr').withHomeAndEnd().skipPredicate(action => this._skipPredicate(action));
      this.chipFocusChanges.pipe(takeUntil(this._destroyed)).subscribe(({
        chip
      }) => {
        const action = chip._getSourceAction(document.activeElement);
        if (action) {
          this._keyManager.updateActiveItem(action);
        }
      });
      this._dir?.change.pipe(takeUntil(this._destroyed)).subscribe(direction => this._keyManager.withHorizontalOrientation(direction));
    }
    _skipPredicate(action) {
      return action.disabled;
    }
    _trackChipSetChanges() {
      this._chips.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
        if (this.disabled) {
          Promise.resolve().then(() => this._syncChipsState());
        }
        this._redirectDestroyedChipFocus();
      });
    }
    _trackDestroyedFocusedChip() {
      this.chipDestroyedChanges.pipe(takeUntil(this._destroyed)).subscribe(event => {
        const chipArray = this._chips.toArray();
        const chipIndex = chipArray.indexOf(event.chip);
        const hasFocus = event.chip._hasFocus();
        const wasLastFocused = event.chip._hadFocusOnRemove && this._keyManager.activeItem && event.chip._getActions().includes(this._keyManager.activeItem);
        const shouldMoveFocus = hasFocus || wasLastFocused;
        if (this._isValidIndex(chipIndex) && shouldMoveFocus) {
          this._lastDestroyedFocusedChipIndex = chipIndex;
        }
      });
    }
    _redirectDestroyedChipFocus() {
      if (this._lastDestroyedFocusedChipIndex == null) {
        return;
      }
      if (this._chips.length) {
        const newIndex = Math.min(this._lastDestroyedFocusedChipIndex, this._chips.length - 1);
        const chipToFocus = this._chips.toArray()[newIndex];
        if (chipToFocus.disabled) {
          if (this._chips.length === 1) {
            this.focus();
          } else {
            this._keyManager.setPreviousItemActive();
          }
        } else {
          chipToFocus.focus();
        }
      } else {
        this.focus();
      }
      this._lastDestroyedFocusedChipIndex = null;
    }
    static ɵfac = function MatChipSet_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipSet)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipSet,
      selectors: [["mat-chip-set"]],
      contentQueries: function MatChipSet_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChip, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._chips = _t);
        }
      },
      hostAttrs: [1, "mat-mdc-chip-set", "mdc-evolution-chip-set"],
      hostVars: 1,
      hostBindings: function MatChipSet_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MatChipSet_keydown_HostBindingHandler($event) {
            return ctx._handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        role: "role",
        tabIndex: [2, "tabIndex", "tabIndex", value => value == null ? 0 : numberAttribute(value)]
      },
      ngContentSelectors: _c5,
      decls: 2,
      vars: 0,
      consts: [["role", "presentation", 1, "mdc-evolution-chip-set__chips"]],
      template: function MatChipSet_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵdomElementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵdomElementEnd();
        }
      },
      styles: [".mat-mdc-chip-set {\n  display: flex;\n}\n.mat-mdc-chip-set:focus {\n  outline: none;\n}\n.mat-mdc-chip-set .mdc-evolution-chip-set__chips {\n  min-width: 100%;\n  margin-left: -8px;\n  margin-right: 0;\n}\n.mat-mdc-chip-set .mdc-evolution-chip {\n  margin: 4px 0 4px 8px;\n}\n[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip-set__chips {\n  margin-left: 0;\n  margin-right: -8px;\n}\n[dir=rtl] .mat-mdc-chip-set .mdc-evolution-chip {\n  margin-left: 0;\n  margin-right: 8px;\n}\n\n.mdc-evolution-chip-set__chips {\n  display: flex;\n  flex-flow: wrap;\n  min-width: 0;\n}\n\n.mat-mdc-chip-set-stacked {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.mat-mdc-chip-set-stacked .mat-mdc-chip {\n  width: 100%;\n}\n.mat-mdc-chip-set-stacked .mdc-evolution-chip__graphic {\n  flex-grow: 0;\n}\n.mat-mdc-chip-set-stacked .mdc-evolution-chip__action--primary {\n  flex-basis: 100%;\n  justify-content: start;\n}\n\ninput.mat-mdc-chip-input {\n  flex: 1 0 150px;\n  margin-left: 8px;\n}\n[dir=rtl] input.mat-mdc-chip-input {\n  margin-left: 0;\n  margin-right: 8px;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input::placeholder {\n  opacity: 1;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input::-moz-placeholder {\n  opacity: 1;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input::-webkit-input-placeholder {\n  opacity: 1;\n}\n.mat-mdc-form-field:not(.mat-form-field-hide-placeholder) input.mat-mdc-chip-input:-ms-input-placeholder {\n  opacity: 1;\n}\n.mat-mdc-chip-set + input.mat-mdc-chip-input {\n  margin-left: 0;\n  margin-right: 0;\n}\n"],
      encapsulation: 2
    });
  }
  return MatChipSet;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MatChipListboxChange {
  source;
  value;
  constructor(source, value) {
    this.source = source;
    this.value = value;
  }
}
const MAT_CHIP_LISTBOX_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*#__PURE__*/forwardRef(() => MatChipListbox),
  multi: true
};
let MatChipListbox = /*#__PURE__*/(() => {
  class MatChipListbox extends MatChipSet {
    _onTouched = () => {};
    _onChange = () => {};
    _defaultRole = 'listbox';
    _defaultOptions = inject(MAT_CHIPS_DEFAULT_OPTIONS, {
      optional: true
    });
    get multiple() {
      return this._multiple;
    }
    set multiple(value) {
      this._multiple = value;
      this._syncListboxProperties();
    }
    _multiple = false;
    get selected() {
      const selectedChips = this._chips.toArray().filter(chip => chip.selected);
      return this.multiple ? selectedChips : selectedChips[0];
    }
    ariaOrientation = 'horizontal';
    get selectable() {
      return this._selectable;
    }
    set selectable(value) {
      this._selectable = value;
      this._syncListboxProperties();
    }
    _selectable = true;
    compareWith = (o1, o2) => o1 === o2;
    required = false;
    get hideSingleSelectionIndicator() {
      return this._hideSingleSelectionIndicator;
    }
    set hideSingleSelectionIndicator(value) {
      this._hideSingleSelectionIndicator = value;
      this._syncListboxProperties();
    }
    _hideSingleSelectionIndicator = this._defaultOptions?.hideSingleSelectionIndicator ?? false;
    get chipSelectionChanges() {
      return this._getChipStream(chip => chip.selectionChange);
    }
    get chipBlurChanges() {
      return this._getChipStream(chip => chip._onBlur);
    }
    get value() {
      return this._value;
    }
    set value(value) {
      if (this._chips && this._chips.length) {
        this._setSelectionByValue(value, false);
      }
      this._value = value;
    }
    _value;
    change = new EventEmitter();
    _chips = undefined;
    ngAfterContentInit() {
      this._chips.changes.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
        if (this.value !== undefined) {
          Promise.resolve().then(() => {
            this._setSelectionByValue(this.value, false);
          });
        }
        this._syncListboxProperties();
      });
      this.chipBlurChanges.pipe(takeUntil(this._destroyed)).subscribe(() => this._blur());
      this.chipSelectionChanges.pipe(takeUntil(this._destroyed)).subscribe(event => {
        if (!this.multiple) {
          this._chips.forEach(chip => {
            if (chip !== event.source) {
              chip._setSelectedState(false, false, false);
            }
          });
        }
        if (event.isUserInput) {
          this._propagateChanges();
        }
      });
    }
    focus() {
      if (this.disabled) {
        return;
      }
      const firstSelectedChip = this._getFirstSelectedChip();
      if (firstSelectedChip && !firstSelectedChip.disabled) {
        firstSelectedChip.focus();
      } else if (this._chips.length > 0) {
        this._keyManager.setFirstItemActive();
      } else {
        this._elementRef.nativeElement.focus();
      }
    }
    writeValue(value) {
      if (value != null) {
        this.value = value;
      } else {
        this.value = undefined;
      }
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    _setSelectionByValue(value, isUserInput = true) {
      this._clearSelection();
      if (Array.isArray(value)) {
        value.forEach(currentValue => this._selectValue(currentValue, isUserInput));
      } else {
        this._selectValue(value, isUserInput);
      }
    }
    _blur() {
      if (!this.disabled) {
        setTimeout(() => {
          if (!this.focused) {
            this._markAsTouched();
          }
        });
      }
    }
    _keydown(event) {
      if (event.keyCode === TAB) {
        super._allowFocusEscape();
      }
    }
    _markAsTouched() {
      this._onTouched();
      this._changeDetectorRef.markForCheck();
    }
    _propagateChanges() {
      let valueToEmit = null;
      if (Array.isArray(this.selected)) {
        valueToEmit = this.selected.map(chip => chip.value);
      } else {
        valueToEmit = this.selected ? this.selected.value : undefined;
      }
      this._value = valueToEmit;
      this.change.emit(new MatChipListboxChange(this, valueToEmit));
      this._onChange(valueToEmit);
      this._changeDetectorRef.markForCheck();
    }
    _clearSelection(skip) {
      this._chips.forEach(chip => {
        if (chip !== skip) {
          chip.deselect();
        }
      });
    }
    _selectValue(value, isUserInput) {
      const correspondingChip = this._chips.find(chip => {
        return chip.value != null && this.compareWith(chip.value, value);
      });
      if (correspondingChip) {
        isUserInput ? correspondingChip.selectViaInteraction() : correspondingChip.select();
      }
      return correspondingChip;
    }
    _syncListboxProperties() {
      if (this._chips) {
        Promise.resolve().then(() => {
          this._chips.forEach(chip => {
            chip._chipListMultiple = this.multiple;
            chip.chipListSelectable = this._selectable;
            chip._chipListHideSingleSelectionIndicator = this.hideSingleSelectionIndicator;
            chip._changeDetectorRef.markForCheck();
          });
        });
      }
    }
    _getFirstSelectedChip() {
      if (Array.isArray(this.selected)) {
        return this.selected.length ? this.selected[0] : undefined;
      } else {
        return this.selected;
      }
    }
    _skipPredicate(action) {
      return false;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatChipListbox_BaseFactory;
      return function MatChipListbox_Factory(__ngFactoryType__) {
        return (ɵMatChipListbox_BaseFactory || (ɵMatChipListbox_BaseFactory = i0.ɵɵgetInheritedFactory(MatChipListbox)))(__ngFactoryType__ || MatChipListbox);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipListbox,
      selectors: [["mat-chip-listbox"]],
      contentQueries: function MatChipListbox_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChipOption, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._chips = _t);
        }
      },
      hostAttrs: [1, "mdc-evolution-chip-set", "mat-mdc-chip-listbox"],
      hostVars: 10,
      hostBindings: function MatChipListbox_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatChipListbox_focus_HostBindingHandler() {
            return ctx.focus();
          })("blur", function MatChipListbox_blur_HostBindingHandler() {
            return ctx._blur();
          })("keydown", function MatChipListbox_keydown_HostBindingHandler($event) {
            return ctx._keydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("tabIndex", ctx.disabled || ctx.empty ? -1 : ctx.tabIndex);
          i0.ɵɵattribute("role", ctx.role)("aria-required", ctx.role ? ctx.required : null)("aria-disabled", ctx.disabled.toString())("aria-multiselectable", ctx.multiple)("aria-orientation", ctx.ariaOrientation);
          i0.ɵɵclassProp("mat-mdc-chip-list-disabled", ctx.disabled)("mat-mdc-chip-list-required", ctx.required);
        }
      },
      inputs: {
        multiple: [2, "multiple", "multiple", booleanAttribute],
        ariaOrientation: [0, "aria-orientation", "ariaOrientation"],
        selectable: [2, "selectable", "selectable", booleanAttribute],
        compareWith: "compareWith",
        required: [2, "required", "required", booleanAttribute],
        hideSingleSelectionIndicator: [2, "hideSingleSelectionIndicator", "hideSingleSelectionIndicator", booleanAttribute],
        value: "value"
      },
      outputs: {
        change: "change"
      },
      features: [i0.ɵɵProvidersFeature([MAT_CHIP_LISTBOX_CONTROL_VALUE_ACCESSOR]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c5,
      decls: 2,
      vars: 0,
      consts: [["role", "presentation", 1, "mdc-evolution-chip-set__chips"]],
      template: function MatChipListbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵdomElementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵdomElementEnd();
        }
      },
      styles: [_c6],
      encapsulation: 2
    });
  }
  return MatChipListbox;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MatChipGridChange {
  source;
  value;
  constructor(source, value) {
    this.source = source;
    this.value = value;
  }
}
let MatChipGrid = /*#__PURE__*/(() => {
  class MatChipGrid extends MatChipSet {
    ngControl = inject(NgControl, {
      optional: true,
      self: true
    });
    controlType = 'mat-chip-grid';
    _chipInput;
    _defaultRole = 'grid';
    _errorStateTracker;
    _uid = inject(_IdGenerator).getId('mat-chip-grid-');
    _ariaDescribedbyIds = [];
    _onTouched = () => {};
    _onChange = () => {};
    get disabled() {
      return this.ngControl ? !!this.ngControl.disabled : this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
      this._syncChipsState();
      this.stateChanges.next();
    }
    get id() {
      return this._chipInput ? this._chipInput.id : this._uid;
    }
    get empty() {
      return (!this._chipInput || this._chipInput.empty) && (!this._chips || this._chips.length === 0);
    }
    get placeholder() {
      return this._chipInput ? this._chipInput.placeholder : this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    _placeholder = '';
    get focused() {
      return this._chipInput?.focused || this._hasFocusedChip();
    }
    get required() {
      return this._required ?? this.ngControl?.control?.hasValidator(Validators.required) ?? false;
    }
    set required(value) {
      this._required = value;
      this.stateChanges.next();
    }
    _required;
    get shouldLabelFloat() {
      return !this.empty || this.focused;
    }
    get value() {
      return this._value;
    }
    set value(value) {
      this._value = value;
    }
    _value = [];
    get errorStateMatcher() {
      return this._errorStateTracker.matcher;
    }
    set errorStateMatcher(value) {
      this._errorStateTracker.matcher = value;
    }
    get chipBlurChanges() {
      return this._getChipStream(chip => chip._onBlur);
    }
    change = new EventEmitter();
    valueChange = new EventEmitter();
    _chips = undefined;
    stateChanges = new Subject();
    get errorState() {
      return this._errorStateTracker.errorState;
    }
    set errorState(value) {
      this._errorStateTracker.errorState = value;
    }
    constructor() {
      super();
      const parentForm = inject(NgForm, {
        optional: true
      });
      const parentFormGroup = inject(FormGroupDirective, {
        optional: true
      });
      const defaultErrorStateMatcher = inject(ErrorStateMatcher);
      if (this.ngControl) {
        this.ngControl.valueAccessor = this;
      }
      this._errorStateTracker = new _ErrorStateTracker(defaultErrorStateMatcher, this.ngControl, parentFormGroup, parentForm, this.stateChanges);
    }
    ngAfterContentInit() {
      this.chipBlurChanges.pipe(takeUntil(this._destroyed)).subscribe(() => {
        this._blur();
        this.stateChanges.next();
      });
      merge(this.chipFocusChanges, this._chips.changes).pipe(takeUntil(this._destroyed)).subscribe(() => this.stateChanges.next());
    }
    ngDoCheck() {
      if (this.ngControl) {
        this.updateErrorState();
      }
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this.stateChanges.complete();
    }
    registerInput(inputElement) {
      this._chipInput = inputElement;
      this._chipInput.setDescribedByIds(this._ariaDescribedbyIds);
      this._elementRef.nativeElement.removeAttribute('aria-describedby');
    }
    onContainerClick(event) {
      if (!this.disabled && !this._originatesFromChip(event)) {
        this.focus();
      }
    }
    focus() {
      if (this.disabled || this._chipInput?.focused) {
        return;
      }
      if (!this._chips.length || this._chips.first.disabled) {
        if (!this._chipInput) {
          return;
        }
        Promise.resolve().then(() => this._chipInput.focus());
      } else {
        const activeItem = this._keyManager.activeItem;
        if (activeItem) {
          activeItem.focus();
        } else {
          this._keyManager.setFirstItemActive();
        }
      }
      this.stateChanges.next();
    }
    get describedByIds() {
      if (this._chipInput) {
        return this._chipInput.describedByIds || [];
      }
      const existing = this._elementRef.nativeElement.getAttribute('aria-describedby');
      return existing ? existing.split(' ') : [];
    }
    setDescribedByIds(ids) {
      this._ariaDescribedbyIds = ids;
      if (this._chipInput) {
        this._chipInput.setDescribedByIds(ids);
      } else if (ids.length) {
        this._elementRef.nativeElement.setAttribute('aria-describedby', ids.join(' '));
      } else {
        this._elementRef.nativeElement.removeAttribute('aria-describedby');
      }
    }
    writeValue(value) {
      this._value = value;
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
      this.stateChanges.next();
    }
    updateErrorState() {
      this._errorStateTracker.updateErrorState();
    }
    _blur() {
      if (!this.disabled) {
        setTimeout(() => {
          if (!this.focused) {
            this._propagateChanges();
            this._markAsTouched();
          }
        });
      }
    }
    _allowFocusEscape() {
      if (!this._chipInput?.focused) {
        super._allowFocusEscape();
      }
    }
    _handleKeydown(event) {
      const keyCode = event.keyCode;
      const activeItem = this._keyManager.activeItem;
      if (keyCode === TAB) {
        if (this._chipInput?.focused && hasModifierKey(event, 'shiftKey') && this._chips.length && !this._chips.last.disabled) {
          event.preventDefault();
          if (activeItem) {
            this._keyManager.setActiveItem(activeItem);
          } else {
            this._focusLastChip();
          }
        } else {
          super._allowFocusEscape();
        }
      } else if (!this._chipInput?.focused) {
        if ((keyCode === UP_ARROW || keyCode === DOWN_ARROW) && activeItem) {
          const eligibleActions = this._chipActions.filter(action => action._isPrimary === activeItem._isPrimary && !this._skipPredicate(action));
          const currentIndex = eligibleActions.indexOf(activeItem);
          const delta = event.keyCode === UP_ARROW ? -1 : 1;
          event.preventDefault();
          if (currentIndex > -1 && this._isValidIndex(currentIndex + delta)) {
            this._keyManager.setActiveItem(eligibleActions[currentIndex + delta]);
          }
        } else {
          super._handleKeydown(event);
        }
      }
      this.stateChanges.next();
    }
    _redirectDestroyedChipFocus() {
      if (this._lastDestroyedFocusedChipIndex === null) {
        return;
      }
      super._redirectDestroyedChipFocus();
      if (!this._chips.length || this._chips.length === 1 && this._chips.first.disabled) {
        this._keyManager.updateActiveItem(-1);
      }
    }
    _focusLastChip() {
      if (this._chips.length) {
        this._chips.last.focus();
      }
    }
    _propagateChanges() {
      const valueToEmit = this._chips.length ? this._chips.toArray().map(chip => chip.value) : [];
      this._value = valueToEmit;
      this.change.emit(new MatChipGridChange(this, valueToEmit));
      this.valueChange.emit(valueToEmit);
      this._onChange(valueToEmit);
      this._changeDetectorRef.markForCheck();
    }
    _markAsTouched() {
      this._onTouched();
      this._changeDetectorRef.markForCheck();
      this.stateChanges.next();
    }
    static ɵfac = function MatChipGrid_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipGrid)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatChipGrid,
      selectors: [["mat-chip-grid"]],
      contentQueries: function MatChipGrid_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatChipRow, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._chips = _t);
        }
      },
      hostAttrs: [1, "mat-mdc-chip-set", "mat-mdc-chip-grid", "mdc-evolution-chip-set"],
      hostVars: 10,
      hostBindings: function MatChipGrid_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function MatChipGrid_focus_HostBindingHandler() {
            return ctx.focus();
          })("blur", function MatChipGrid_blur_HostBindingHandler() {
            return ctx._blur();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role)("tabindex", ctx.disabled || ctx._chips && ctx._chips.length === 0 ? -1 : ctx.tabIndex)("aria-disabled", ctx.disabled.toString())("aria-invalid", ctx.errorState);
          i0.ɵɵclassProp("mat-mdc-chip-list-disabled", ctx.disabled)("mat-mdc-chip-list-invalid", ctx.errorState)("mat-mdc-chip-list-required", ctx.required);
        }
      },
      inputs: {
        disabled: [2, "disabled", "disabled", booleanAttribute],
        placeholder: "placeholder",
        required: [2, "required", "required", booleanAttribute],
        value: "value",
        errorStateMatcher: "errorStateMatcher"
      },
      outputs: {
        change: "change",
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: MatFormFieldControl,
        useExisting: MatChipGrid
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c5,
      decls: 2,
      vars: 0,
      consts: [["role", "presentation", 1, "mdc-evolution-chip-set__chips"]],
      template: function MatChipGrid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵdomElementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵdomElementEnd();
        }
      },
      styles: [_c6],
      encapsulation: 2
    });
  }
  return MatChipGrid;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatChipInput = /*#__PURE__*/(() => {
  class MatChipInput {
    _elementRef = inject(ElementRef);
    focused = false;
    get chipGrid() {
      return this._chipGrid;
    }
    set chipGrid(value) {
      if (value) {
        this._chipGrid = value;
        this._chipGrid.registerInput(this);
      }
    }
    _chipGrid;
    addOnBlur = false;
    separatorKeyCodes;
    chipEnd = new EventEmitter();
    placeholder = '';
    id = inject(_IdGenerator).getId('mat-mdc-chip-list-input-');
    get disabled() {
      return this._disabled || this._chipGrid && this._chipGrid.disabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled = false;
    readonly = false;
    disabledInteractive;
    get empty() {
      return !this.inputElement.value;
    }
    inputElement;
    constructor() {
      const defaultOptions = inject(MAT_CHIPS_DEFAULT_OPTIONS);
      const formField = inject(MAT_FORM_FIELD, {
        optional: true
      });
      this.inputElement = this._elementRef.nativeElement;
      this.separatorKeyCodes = defaultOptions.separatorKeyCodes;
      this.disabledInteractive = defaultOptions.inputDisabledInteractive ?? false;
      if (formField) {
        this.inputElement.classList.add('mat-mdc-form-field-input-control');
      }
    }
    ngOnChanges() {
      this._chipGrid.stateChanges.next();
    }
    ngOnDestroy() {
      this.chipEnd.complete();
    }
    _keydown(event) {
      if (this.empty && event.keyCode === BACKSPACE) {
        if (!event.repeat) {
          this._chipGrid._focusLastChip();
        }
        event.preventDefault();
      } else {
        this._emitChipEnd(event);
      }
    }
    _blur() {
      if (this.addOnBlur) {
        this._emitChipEnd();
      }
      this.focused = false;
      if (!this._chipGrid.focused) {
        this._chipGrid._blur();
      }
      this._chipGrid.stateChanges.next();
    }
    _focus() {
      this.focused = true;
      this._chipGrid.stateChanges.next();
    }
    _emitChipEnd(event) {
      if (!event || this._isSeparatorKey(event) && !event.repeat) {
        this.chipEnd.emit({
          input: this.inputElement,
          value: this.inputElement.value,
          chipInput: this
        });
        event?.preventDefault();
      }
    }
    _onInput() {
      this._chipGrid.stateChanges.next();
    }
    focus() {
      this.inputElement.focus();
    }
    clear() {
      this.inputElement.value = '';
    }
    get describedByIds() {
      const element = this._elementRef.nativeElement;
      const existingDescribedBy = element.getAttribute('aria-describedby');
      return existingDescribedBy?.split(' ') || [];
    }
    setDescribedByIds(ids) {
      const element = this._elementRef.nativeElement;
      if (ids.length) {
        element.setAttribute('aria-describedby', ids.join(' '));
      } else {
        element.removeAttribute('aria-describedby');
      }
    }
    _isSeparatorKey(event) {
      if (!this.separatorKeyCodes) {
        return false;
      }
      for (const key of this.separatorKeyCodes) {
        let keyCode;
        let modifiers;
        if (typeof key === 'number') {
          keyCode = key;
          modifiers = null;
        } else {
          keyCode = key.keyCode;
          modifiers = key.modifiers;
        }
        const modifiersMatch = !modifiers?.length ? !hasModifierKey(event) : hasModifierKey(event, ...modifiers);
        if (keyCode === event.keyCode && modifiersMatch) {
          return true;
        }
      }
      return false;
    }
    _getReadonlyAttribute() {
      return this.readonly || this.disabled && this.disabledInteractive ? 'true' : null;
    }
    static ɵfac = function MatChipInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipInput)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatChipInput,
      selectors: [["input", "matChipInputFor", ""]],
      hostAttrs: [1, "mat-mdc-chip-input", "mat-mdc-input-element", "mdc-text-field__input", "mat-input-element"],
      hostVars: 8,
      hostBindings: function MatChipInput_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function MatChipInput_keydown_HostBindingHandler($event) {
            return ctx._keydown($event);
          })("blur", function MatChipInput_blur_HostBindingHandler() {
            return ctx._blur();
          })("focus", function MatChipInput_focus_HostBindingHandler() {
            return ctx._focus();
          })("input", function MatChipInput_input_HostBindingHandler() {
            return ctx._onInput();
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("id", ctx.id);
          i0.ɵɵattribute("disabled", ctx.disabled && !ctx.disabledInteractive ? "" : null)("placeholder", ctx.placeholder || null)("aria-invalid", ctx._chipGrid && ctx._chipGrid.ngControl ? ctx._chipGrid.ngControl.invalid : null)("aria-required", ctx._chipGrid && ctx._chipGrid.required || null)("aria-disabled", ctx.disabled && ctx.disabledInteractive ? "true" : null)("readonly", ctx._getReadonlyAttribute())("required", ctx._chipGrid && ctx._chipGrid.required || null);
        }
      },
      inputs: {
        chipGrid: [0, "matChipInputFor", "chipGrid"],
        addOnBlur: [2, "matChipInputAddOnBlur", "addOnBlur", booleanAttribute],
        separatorKeyCodes: [0, "matChipInputSeparatorKeyCodes", "separatorKeyCodes"],
        placeholder: "placeholder",
        id: "id",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        readonly: [2, "readonly", "readonly", booleanAttribute],
        disabledInteractive: [2, "matChipInputDisabledInteractive", "disabledInteractive", booleanAttribute]
      },
      outputs: {
        chipEnd: "matChipInputTokenEnd"
      },
      exportAs: ["matChipInput", "matChipInputFor"],
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return MatChipInput;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CHIP_DECLARATIONS = [MatChip, MatChipAvatar, MatChipEdit, MatChipEditInput, MatChipGrid, MatChipInput, MatChipListbox, MatChipOption, MatChipRemove, MatChipRow, MatChipSet, MatChipTrailingIcon];
let MatChipsModule = /*#__PURE__*/(() => {
  class MatChipsModule {
    static ɵfac = function MatChipsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatChipsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatChipsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ErrorStateMatcher, {
        provide: MAT_CHIPS_DEFAULT_OPTIONS,
        useValue: {
          separatorKeyCodes: [ENTER]
        }
      }],
      imports: [MatRippleModule, BidiModule]
    });
  }
  return MatChipsModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MAT_CHIP, MAT_CHIPS_DEFAULT_OPTIONS, MAT_CHIP_AVATAR, MAT_CHIP_EDIT, MAT_CHIP_LISTBOX_CONTROL_VALUE_ACCESSOR, MAT_CHIP_REMOVE, MAT_CHIP_TRAILING_ICON, MatChip, MatChipAvatar, MatChipEdit, MatChipEditInput, MatChipGrid, MatChipGridChange, MatChipInput, MatChipListbox, MatChipListboxChange, MatChipOption, MatChipRemove, MatChipRow, MatChipSelectionChange, MatChipSet, MatChipTrailingIcon, MatChipsModule };
